<template>
  <el-form ref="elFormRef" :model="model" :rules="rulesComputed" :inline="inline" :label-width="labelWidthComputed"
    :label-position="labelPosition" :label-suffix="labelSuffix" :hide-required-asterisk="hideRequiredAsterisk"
    :require-asterisk-position="requireAsteriskPosition" :show-message="showMessage" :inline-message="inlineMessage"
    :statusIcon="statusIcon" :validate-on-rule-change="validateOnRuleChange" :scroll-to-error="scrollToError"
    :scroll-into-view-options="scrollIntoViewOptions" @validate="validateEmit">
    <slot></slot>
  </el-form>
</template>

<script>
import useAppStore from '@/store/modules/app';
import { i18nConfig } from '@/utils/ruoyi'
import { reactive, toRefs, computed } from 'vue'
export default {
  name: "gljy-form",
  emits: ["validate", "update:value"],
  props: {
    model: {
      type: Object
    },
    rules: {
      type: Object
    },
    inline: {
      type: Boolean
    },
    labelPosition: {
      type: String
    },
    labelWidth: {
      type: [String, Number]
    },
    labelSuffix: String,
    hideRequiredAsterisk: {
      type: Boolean
    }, // 是否隐藏必填字段标签旁边的红色星号。
    requireAsteriskPosition: String, // 星号位置
    showMessage: {
      type: Boolean,
      default: () => {
        return true;
      }
    }, // 是否显示错误信息
    inlineMessage: {
      type: Boolean
    }, // 是否以行内形式展示校验信息
    statusIcon: {
      type: Boolean
    }, // 是否在输入框中显示校验结果反馈图标
    validateOnRuleChange: {
      type: Boolean,
      default: () => {
        return true;
      }
    }, // 是否在 rules 属性改变后立即触发一次验证
    size: String, // '' | 'large' | 'default' | 'small'
    scrollToError: {
      type: Boolean
    }, // 当校验失败时，滚动到第一个错误表单项
    scrollIntoViewOptions: {
      type: [Object, Boolean]
    }, // 当校验有失败结果时，滚动到第一个失败的表单项目 可通过 scrollIntoView 配置
  },
  setup(props, context) {
    const appStore = useAppStore();
    const elFormRef = ref();
    const datas = reactive({
      newValue: undefined,
      i18nConfig: i18nConfig
    })

    const labelWidthComputed = computed(() => {
      const locale = appStore.locale;
      if(locale != "zh" && props.labelWidth != null && props.labelWidth != ''){
        return Number(props.labelWidth.replace("px", "")) * 2 + "px";
      }
      return props.labelWidth;
    })

    const rulesComputed = computed(() => {
      const rules = props.rules;
      if(!rules) return {};
      const resultRules = {};
      Object.keys(rules).forEach(key => {
        const rulesList = rules[key];
        const resultRulesList = [];
        rulesList.forEach(item => {
          let resultItem = {};
          Object.keys(item).forEach(itemKey => {
            let itemVal = item[itemKey];
            if(itemKey === "message"){
              itemVal = i18nConfig(item[itemKey]);
            }
            resultItem[itemKey] = itemVal;
          })
          resultRulesList.push(resultItem);
        })
        resultRules[key] = resultRulesList;
      })
      return resultRules;
    })

    const methods = {
      validateEmit(formItemProp, isValid, message) {
        context.emit("validate", formItemProp, isValid, message);
      },
    }

    const exposesFunction = {
      async validate(callback) {
        return await elFormRef.value.validate(callback);
      },
      validateField(arrayable, callback) {
        elFormRef.value.validateField(arrayable, callback)
      },
      resetFields(arrayable) {
        elFormRef.value.resetFields(arrayable)
      },
      scrollToField(formItemProp) {
        elFormRef.value.scrollToField(formItemProp)
      },
      clearValidate(arrayable) {
        elFormRef.value.clearValidate(arrayable)
      },
      fields() {
        return elFormRef.value.fields()
      }
    }


    return {
      labelWidthComputed,
      ...toRefs(datas),
      ...exposesFunction,
      elFormRef,
      ...methods,
      rulesComputed
    }
  }
}
</script>

<style lang="scss" scoped>
.file-box {
  display: flex;
  flex-wrap: wrap;

  .fileitem-box {
    width: 80px;
    height: 80px;
    margin-right: 10px;
  }
}
</style>